import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button, Icon, Popup, Table,
} from 'semantic-ui-react';

import { keyType } from '../types';

import RemeetingTimestamp from '../utils/remeeting-timestamp';

import { openModal, setKeyAuthAction } from '../../modules/keys';
import { copyStringToClipboard } from '../../modules/utils';

import '../../stylesheets/keys.css';

export class KeyTr extends Component {
  handleDelete = (e) => {
    const { connectedOpenModal, connectedSetKeyAuthAction, apiKey } = this.props;
    e.preventDefault();
    connectedSetKeyAuthAction(apiKey, 'keyDelete');
    connectedOpenModal();
  }

  handleRename = (e) => {
    const { connectedOpenModal, connectedSetKeyAuthAction, apiKey } = this.props;
    e.preventDefault();
    connectedSetKeyAuthAction(apiKey, 'keyPut');
    connectedOpenModal();
  }

  truncateId = (id, n) => {
    if (id.length < n) {
      return id;
    }
    const subString = id.substr(0, n - 1);
    return `${subString}...`;
  }

  copyId = (id) => {
    copyStringToClipboard(id);
  }

  render() {
    const {
      apiKey,
    } = this.props;
    return (
      <Table.Row>
        <Table.Cell>
          <RemeetingTimestamp date={apiKey.created} />
        </Table.Cell>
        <Table.Cell>
          { apiKey.name }
        </Table.Cell>
        <Table.Cell>
          { this.truncateId(apiKey.id, 8) }
        </Table.Cell>
        <Table.Cell>
          {
            <Button.Group>
              <Popup
                trigger={
                  (
                    <Button
                      compact
                      onClick={() => { this.copyId(apiKey.id); }}
                    >
                      <Icon className="copy-icon" name="copy" />
                    </Button>
                  )
                }
                content="Copy key id to clipboard"
              />
              <Button
                compact
                content="Rename"
                onClick={this.handleRename}
              />
              <Button
                compact
                content="Delete"
                negative
                onClick={this.handleDelete}
              />
            </Button.Group>
          }
        </Table.Cell>
      </Table.Row>
    );
  }
}

KeyTr.propTypes = {
  apiKey: keyType.isRequired,
  connectedOpenModal: PropTypes.func.isRequired,
  connectedSetKeyAuthAction: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedOpenModal: openModal,
  connectedSetKeyAuthAction: setKeyAuthAction,
}, dispatch);

export default connect(
  undefined,
  mapDispatchToProps,
)(KeyTr);
